const FEEDBACK_STATUS = {
  SENT: 'Sent',
  REVIEWED: 'Reviewed'
};

const FEEDBACK_REQUESTED_BY = {
  SYSTEM: 'system'
};

export { FEEDBACK_STATUS, FEEDBACK_REQUESTED_BY };
